<template>
  <section class="invoice-form-section">
    <invoice-form-section-header
      :title="this.title"
      :currentStep="this.currentStep"
      :totalSteps="this.totalSteps"
    />
    <slot></slot>
  </section>
</template>

<script>
import InvoiceFormSectionHeader from './InvoiceFormSectionHeader.vue'

export default {
  name: 'InvoiceFormSection',
  components: {
    InvoiceFormSectionHeader
  },
  props: {
    title: {
      type: String
    },
    currentStep: {
      type: Number
    },
    totalSteps: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-form-section {
  &:not(:first-child) {
    margin: 2rem 0;
  }
}

@media (min-width: 768px) {
  .invoice-form-section {
    display: grid;
    grid-column-gap: 2%;
    grid-template-columns: 68% 30%;
    grid-template-rows: auto auto;
    .invoice-form-section-header {
      grid-column: 1 / 3;
      grid-row: 1;
    }
  }
}
</style>
